import Page from "webPage/Page";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";
import ScrollMagic from "scrollmagic";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";
import {animation, Power0, TimelineMax, TweenMax} from "gsap";
import {scrollMagicActive} from "index";
import ScriptHelper from "base/ScriptHelper";

let parallaxController = null;
let contactTween;
let contactScene;
let messageTween;
let messageScene;

Page.register('/get-in-touch', () => {
    let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyDJvp6qPtbkpO9bUDNIQeTFX1RvNqvxYpg").then(loadMaps);


    FormValidator.attach($('.js-contact-form'), {
        inputOptions: {operator: "your"}
    }).on("input:invalid", function (data) {
        data.input.$input.parents('.form__row').addClass('form__row--error');
    }).on("input:valid", function (data) {
        data.input.$input.parents('.form__row').removeClass('form__row--error')
    }).on("submit", ($form) => {
        let $btn = $form.find("button[type=submit]");
        if ($btn.is(".button--loading")) return;
        $btn.addClass("button--loading");
        $('.form-holder').addClass('form-holder--loading');

        Ajax.post("contact", "", $form.serializeJSON(), Ajax.WEBSITE).then(() => {
            $('.form-holder').removeClass('form-holder--loading');

            $form.parents('.js-form-holder').html('').append(
                eotwJSXFactory('div', {className: "form-message form-message--contact form-message--success"}, [
                    eotwJSXFactory('div', {className: "form-message__wrapper"}, [
                        eotwJSXFactory('span', {className: "svg-icons form-message__icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg?v=1#success"></use></svg>'),
                        eotwJSXFactory('h2', null, ["Thanks For The Message"]),
                        eotwJSXFactory('hr', {className: "form-message__hr-line"}),
                        eotwJSXFactory('p', null, ["One of the team here at Opus International Products will get back to you about your enquiry as soon as they can."])
                    ])
                ])
            );

        }).catch((e) => {
            console.log(e);

            $('.form-holder').removeClass('form-holder--loading');
            $form.parents('.js-form-holder').html('').append(
                eotwJSXFactory('div', {className: "form-message form-message--contact form-message--error"}, [
                    eotwJSXFactory('div', {className: "form-message__wrapper"}, [
                        eotwJSXFactory('span', {className: "svg-icons form-message__icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg?v=1#error"></use></svg>'),
                        eotwJSXFactory('h2', null, ["there was a problem"]),
                        eotwJSXFactory('hr', {className: "form-message__hr-line"}),
                        eotwJSXFactory('p', null, ["Sorry, we couldn’t send your message. Please contact us at ", eotwJSXFactory('a', {href: "mailto:enquiries@opusproducts.com"}, ["enquiries@opusproducts.com"])," instead and we’ll get back to you. We apologise for the inconvenience."])
                    ])
                ])
            );
        });

    });


    parallaxController = new ScrollMagic.Controller();

    contactTween = new TimelineMax()
        .add([
            //TweenMax.fromTo('.js-message', 1, {yPercent: 30, xPercent: 0}, {yPercent: -15, xPercent: 0, ease: Power0.easeNone}),
            TweenMax.fromTo('.js-floating-product-1', 1, {yPercent: 20, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
        ]);

    contactScene = new ScrollMagic.Scene({
        triggerElement: '.overlap--contact-us .overlap__image',
        duration: contactGetHeight,
        triggerHook: "onEnter"
    }).setTween(contactTween).addTo(parallaxController);

    messageTween = new TimelineMax()
        .add([
            //TweenMax.fromTo('.js-message', 1, {yPercent: 30, xPercent: 0}, {yPercent: -15, xPercent: 0, ease: Power0.easeNone}),
            TweenMax.fromTo('.js-floating-product-2', 1, {yPercent: 20, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
        ]);

    messageScene = new ScrollMagic.Scene({
        triggerElement: '.content--contact-us',
        duration: messageGetHeight,
        triggerHook: "onEnter"
    }).setTween(messageTween).addTo(parallaxController);

    windowResizeIndex();
    $(window).on('resize', windowResizeIndex);
});

function loadMaps() {
    let mapb = new google.maps.Map(document.getElementById('map-get-in-touch'), {
        center: {lat: 52.286380, lng: -1.605975},
        zoom: 14,
        scrollwheel: false, //removes scroll wheel functionality
        disableDefaultUI: true, //removes zoom control & street view
        mapTypeControl: false, //removes changing the map type (Road, Satellite etc)
        draggable: true, //stops the map being draggable (for mobile)
        scaleControl: false, //
        zoomControl: false, //stops zooming functionality
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#6791a8"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#1a3646"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#4b6878"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#64779e"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#4b6878"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#334e87"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#023e58"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#283d6a"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#6f9ba5"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#023e58"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#3C7680"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#304a7d"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#98a5be"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#2c6675"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#255763"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#b0d5ce"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#023e58"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#98a5be"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#283d6a"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#3a4762"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#192946"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#4e6d70"
                    }
                ]
            }
        ],
    });

    const image = {
        size: new google.maps.Size(41, 50),
        scaledSize: new google.maps.Size(41, 50),
        anchor: new google.maps.Point(20, 50),
        url: '/images/' + (isIE11 ? 'png' : 'svg') + '/map-marker.' + (isIE11 ? 'png' : 'svg')
    };

    let marker = new google.maps.Marker({
        position: new google.maps.LatLng(52.286380, -1.605975),
        map: mapb,
        icon: image
    });

    google.maps.event.addListener(marker, 'click', function () {
        window.open('https://www.google.co.uk/maps/place/Opus+International+Products+Ltd/@52.2863798,-1.6081636,17z/data=!3m1!4b1!4m5!3m4!1s0x4870cb72adbc1859:0x7b4b009d8282ca42!8m2!3d52.2863798!4d-1.6059749', '_blank');
    });
}

function windowResizeIndex() {

    if (parallaxController === null) return;

    let enabled = scrollMagicActive();

    messageScene.enabled(enabled);
    contactScene.enabled(enabled);

    if (enabled) {
        messageScene.update(true);
        contactScene.update(true);
    } else {
        $('.js-message').attr('style', '');
        $('.js-floating-product-1').attr('style', '');
        $('.js-floating-product-2').attr('style', '');
    }
}

function contactGetHeight() {
    return $('.overlap--contact-us .overlap__image').outerHeight() * 2;
}

function messageGetHeight() {
    return $('.content--contact-us').outerHeight() * 2;
}









